import { createFileRoute } from "@tanstack/react-router";
import { ContactPage } from "@/features/contact/contact-page";
import { i18nLinks, i18nOgMeta } from "@/lib/seo";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact Toolverse — Suggest a Tool or Report a Bug" },
      {
        name: "description",
        content:
          "Get in touch with Toolverse. Suggest a new tool, report a bug, or join our Discord community.",
      },
      {
        property: "og:title",
        content: "Contact Toolverse — Suggest a Tool or Report a Bug",
      },
      {
        property: "og:description",
        content:
          "Suggest a new tool, report a bug, or join the Toolverse Discord community.",
      },
      ...i18nOgMeta("/contact"),
    ],
    links: [...i18nLinks("/contact")],
  }),
  component: ContactPage,
});
